import React, { useEffect } from "react"
import {
    Card,
    CardBody,
    Col,
    Form,
    Button,
    Row,
    Alert
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css";
import moment from "moment";

const summary = (prop) => {
    let { data, leaseDetails, revertModification } = prop;
    return (
        <React.Fragment>
            <Form>

            <Row className="mt-3">
                    <Col xs="12">
                        <Alert color="success" className="text-black" role="alert"> 
                            <div className="d-flex justify-content-between">
                                <div className="my-2">{(leaseDetails.name).toUpperCase()}</div> 
                            </div> 
                        </Alert>                         
                        <Row>
                            <Col md="6">
                                <Card>
                                    <CardBody style={{ paddingTop: '28px' }}>                                        
                                        <Row>
                                            <Col xs="8">
                                                <h6>Lease Modification Date:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                {leaseDetails && leaseDetails.modification_date ? moment.utc(leaseDetails.modification_date).format('MM/DD/YYYY') : ''}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="8">
                                                <h6>Lease End Date:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                {leaseDetails && leaseDetails.terminal_end_date ? moment.utc(leaseDetails.terminal_end_date).format('MM/DD/YYYY') : ''}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="8">
                                                <h6>GAAP - Lease Classification:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                <span style={{textTransform: 'capitalize'}}>{leaseDetails && leaseDetails?.classification}</span>
                                            </Col>
                                        </Row>                                           
                                        <Row>
                                            <Col xs="4">
                                                <h6>Modification Type:</h6>
                                            </Col>
                                            <Col xs="8" style={{ textAlign: 'right' }}>
                                                { leaseDetails && leaseDetails.modification_type && leaseDetails.modification_type == 'liability_decreasing' ? 'Partial Termination - Liability Approach' : leaseDetails && leaseDetails.modification_type && leaseDetails.modification_type == 'rou_decreasing' ? 'Partial Termination - Rou Asset Approach' : 'Not a partial Termination - no gain or loss' }
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md="6">
                                <Card>
                                    <CardBody style={{ paddingTop: '28px' }}>
                                        <Row>
                                            <Col xs="8">
                                                <h6>Discount Rate:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                {leaseDetails && leaseDetails?.discount_rate}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="8">
                                                <h6>Type:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                {leaseDetails.type && (leaseDetails.type).toUpperCase()}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="8">
                                                <h6>State:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                {leaseDetails && leaseDetails.state }
                                            </Col>
                                        </Row> 
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                { data && data.slice(0).reverse().map((d, i) => <>
                    <Row className="mt-3">
                        <Col xs="12">
                            <Alert color="warning" className="text-black" role="alert">
                                <div className="d-flex justify-content-between">
                                    <div className="my-2">{(d.name).toUpperCase()}</div>
                                    <div>
                                        <Button className="btn btn-lbusers" onClick={()=>{
                                            window.open(`/${localStorage.getItem('company')}/leases/details/${d._id}/other`, '_blank')
                                        }}>
                                            VIEW
                                        </Button>
                                    </div>
                                </div>
                            </Alert>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <Card>
                                <CardBody style={{ paddingTop: '28px' }}>
                                    {   
                                        d && d.status == 'Modified' ? 
                                        <Row>
                                            <Col xs="8">
                                                <h6>Lease Modification Date:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                {d && d.modification_date ? moment.utc(d.modification_date).format('MM/DD/YYYY') : ''}
                                            </Col>
                                        </Row> 
                                        :
                                        <Row>
                                            <Col xs="8">
                                                <h6>Lease Commencement Date:</h6>
                                            </Col>
                                            <Col xs="4" style={{ textAlign: 'right' }}>
                                                {d && d.commencement ? moment.utc(d.commencement).format('MM/DD/YYYY') : ''}
                                            </Col>
                                        </Row>
                                    }                                     
                                    <Row>
                                        <Col xs="8">
                                            <h6>Lease End Date:</h6>
                                        </Col>
                                        <Col xs="4" style={{ textAlign: 'right' }}>
                                            {d && d.terminal_end_date ? moment.utc(d.terminal_end_date).format('MM/DD/YYYY') : ''}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="8">
                                            <h6>GAAP - Lease Classification:</h6>
                                        </Col>
                                        <Col xs="4" style={{ textAlign: 'right' }}>
                                            <span style={{textTransform: 'capitalize'}}>{d && d?.classification}</span>
                                        </Col>
                                    </Row>
                                    {   
                                        d && d.status == 'Modified' ? 
                                        <Row>
                                            <Col xs="4">
                                                <h6>Modification Type:</h6>
                                            </Col>
                                            <Col xs="8" style={{ textAlign: 'right' }}>
                                                { d && d.modification_type && d.modification_type == 'liability_decreasing' ? 'Partial Termination - Liability Approach' : d && d.modification_type && d.modification_type == 'rou_decreasing' ? 'Partial Termination - Rou Asset Approach' : 'Not a partial Termination - no gain or loss' }
                                            </Col>
                                        </Row> 
                                        :''
                                    }    
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6">
                            <Card>
                                <CardBody style={{ paddingTop: '28px' }}>
                                    <Row>
                                        <Col xs="8">
                                            <h6>Discount Rate:</h6>
                                        </Col>
                                        <Col xs="4" style={{ textAlign: 'right' }}>
                                            {d && d?.discount_rate}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="8">
                                            <h6>Type:</h6>
                                        </Col>
                                        <Col xs="4" style={{ textAlign: 'right' }}>
                                            {d.type && (d.type).toUpperCase()}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="8">
                                            <h6>State:</h6>
                                        </Col>
                                        <Col xs="4" style={{ textAlign: 'right' }}>
                                            {d && d.state }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </>)}
            </Form>
        </React.Fragment>
    )
}

export default summary